const removeItemByKey = async (key) => {
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: 0 }),
  });
};

const handleCustomCartLogic = async () => {
  const cart = await fetch('/cart.js').then((r) => r.json());

  const starterSetItem = cart.items.find((item) => item.properties?.bundle_root === 'StarterSet');
  const starterSetKey = starterSetItem?.key;

  const bundleItems = cart.items.filter((item) => item.properties?.bundle_attached_to === 'StarterSet');
  const bundleKeys = bundleItems.map((item) => item.key);

  document.querySelectorAll('.slidecarthq .item').forEach((el) => {
    const id = parseInt(el.dataset.variantId, 10);
    if (bundleItems.some((i) => i.variant_id === id)) {
      el.querySelector('.upgrade-to-subscription')?.classList.add('hidden');
      el.querySelector('.quantity-selector')?.classList.add('hidden');
      el.querySelector('.remove')?.setAttribute('disabled', 'disabled');
    }
  });

  if (!starterSetItem && bundleItems.length > 0) {
    for (const key of bundleKeys) await removeItemByKey(key);
    window.SLIDECART_UPDATE?.();
    return;
  }

  const allAttachedCount = starterSetItem.properties['_bundle_additional_option'] === "true" ?  window.bundleItemsAdditional?.length || 0 : window.bundleItems?.length || 0;
  if (starterSetItem && bundleItems.length < allAttachedCount) {
    await removeItemByKey(starterSetKey);
    for (const key of bundleKeys) await removeItemByKey(key);
    window.SLIDECART_UPDATE?.();
  }
};

const observer = new MutationObserver(() => {
  handleCustomCartLogic();
});

const waitForCartElement = () => {
  const cartRoot = document.querySelector('.slidecarthq');

  if (cartRoot) {
    observer.observe(cartRoot, {
      childList: true,
      subtree: true,
    });
    handleCustomCartLogic();
  } else {
    setTimeout(waitForCartElement, 300);
  }
};

document.addEventListener('DOMContentLoaded', waitForCartElement);
